import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=d5c7c4e8"
import script from "./Licenses.vue?vue&type=script&lang=js"
export * from "./Licenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5c7c4e8')) {
      api.createRecord('d5c7c4e8', component.options)
    } else {
      api.reload('d5c7c4e8', component.options)
    }
    module.hot.accept("./Licenses.vue?vue&type=template&id=d5c7c4e8", function () {
      api.rerender('d5c7c4e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Licenses.vue"
export default component.exports